export const CHAT_ID_URL_PARAM = "chatid";

export const CONVERSACAO_URL_PARAM_KEYS = [
  CHAT_ID_URL_PARAM,
  "chatId",
  "chat_id",
  "conversacaoId",
  "conversacao",
];

const AUTO_RESUME_DISABLED_VALUES = new Set(["0", "false", "no"]);

export const getConversacaoIdFromSearch = (search = "") => {
  const params = new URLSearchParams(search);

  for (const key of CONVERSACAO_URL_PARAM_KEYS) {
    const value = params.get(key)?.trim();
    if (value) return value;
  }

  return "";
};

export const getConversacaoIdFromUrl = () => {
  if (typeof window === "undefined") return "";

  return getConversacaoIdFromSearch(window.location.search);
};

export const shouldAutoResumeFromUrl = (search = "") => {
  if (typeof window === "undefined") return false;

  const params = new URLSearchParams(search || window.location.search);
  const conversacaoId = getConversacaoIdFromSearch(params.toString());

  if (!conversacaoId) return false;

  const autoResume = params.get("autoResume") ?? params.get("resume");
  if (autoResume && AUTO_RESUME_DISABLED_VALUES.has(autoResume.toLowerCase())) {
    return false;
  }

  return true;
};

export const clearConversacaoIdFromUrl = () => {
  if (typeof window === "undefined") return;

  const url = new URL(window.location.href);

  CONVERSACAO_URL_PARAM_KEYS.forEach((key) => url.searchParams.delete(key));
  url.searchParams.delete("autoResume");
  url.searchParams.delete("resume");

  window.history.replaceState({}, "", url.toString());
};
